/** Mirrors ComponentActionType.php: what an option grid or action list does when the user picks one of its entries. */
export enum ComponentActionType {
  CONNECT_SOCIAL_ACCOUNT = 'connect_social_account',
  RECONNECT_SOCIAL_ACCOUNT = 'reconnect_social_account',
}

/** One entry of an option grid or action list, as the action sees it. */
export interface ComponentActionTarget {
  id: string;
  label: string;
  meta?: string;
  /** The per-domain data the server attached for the action; the general widgets never read it. */
  actionData?: Record<string, unknown>;
}

export type ComponentActionDoneHandler = (target: ComponentActionTarget) => void;

/** What a widget holds for as long as it is mounted: starting an entry never blocks another start. */
export interface ComponentActionSession {
  start: (target: ComponentActionTarget) => void;
  close: () => void;
}

export interface ComponentAction {
  actionType: ComponentActionType;
  /** Opens the widget's one listener; onDone is called for each entry the action finishes. */
  openSession: (onDone: ComponentActionDoneHandler) => ComponentActionSession;
  /** The chat turn sent when an entry is done — also how a restored chat knows the entry was already done. */
  resumePromptFor: (target: ComponentActionTarget) => string;
  doneLabelKey: string;
  /** Opens the upgrade path offered beside a limit notice. */
  openUpgrade?: () => void;
}

export interface ComponentActionEntries {
  doneTargetIds: string[];
  startAction: (target: ComponentActionTarget) => void;
}
